export enum WorkflowViewingMode {
    BuilderMode = 'BuilderMode',
    PermissionsMode = 'PermissionsMode'
    //SummaryMode = 'SummaryMode'
}
